import { AxiosInstance } from 'axios';

import { ApiResponse } from '@src/types/api/response/api-response';

/**
 * First key: Source Currency
 * Second key: Target Currency
 * Value: Exchange Rate
 */
export type CurrenciesHash = Record<string, Record<string, number>>;

export class CurrencyService {
  constructor(private readonly axiosInstance: AxiosInstance) {}

  public async getCurrencyHash(): Promise<CurrenciesHash> {
    const response = await this.axiosInstance.get<ApiResponse<CurrenciesHash>>('currency-rates-hash');
    const res = response.data.data;

    return res;
  }
}
